import React, { useEffect, useState } from 'react'
// import { IconButton, Menu, MenuItem } from '@mui/material';
// import { Link, useLocation } from 'react-router-dom';
import DefaultLayout from '../reusableComponents/defaultLayout';
import AccountHeader from '../components/account/AccountHeader';
import AccountContent from '../components/account/AccountContent';
import AccountPanel from '../components/account/AccountPanel';
// import Carousel from '../reusableComponents/carousel';


export default function Biderlist() {

    return (
        <DefaultLayout>
            <AccountHeader showTabs={false} />
            <AccountContent>
                <AccountPanel>
                    <div className="list_table">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">Bidder Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Phone Number</th>
                                        <th scope="col">Bidding Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan="12" className='text-center'>No one has Bid yet</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </AccountPanel>
            </AccountContent>
        </DefaultLayout>
    )
}
